<template>
  <PanelBox
    :title-arr="['企业类型', '企业运行状态统计']"
    height="255"
    other-style="padding-top: 0"
    @change="onChange"
  >
    <echart-pie :chart-data="chartData"></echart-pie>
  </PanelBox>
</template>

<script>
import PanelBox from '@/components/TownPanel/PanelBox/PanelBox.vue'
import EchartPie from '@/components/TownPanel/chart/EchartPie.vue'
import { enterpriseTypeChart, operatingStatusChart } from '../mockData/mockData'
export default {
  components: {
    PanelBox,
    EchartPie
  },
  data() {
    return {
      chartData: []
    }
  },
  methods: {
    onChange(index) {
      if (index === 0) {
        this.chartData = enterpriseTypeChart
      } else {
        this.chartData = operatingStatusChart
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
